// Kenya destination — metadata + packages DERIVED from the single source
// (data/kenyaSafariData.js). No hand-maintained package copy lives here anymore,
// so the AI planner and the /safaris hub can never drift from the Kenya page.
import { safariPackages } from '../kenyaSafariData';
import { canonicalPackage, minSeasonPrice } from './adapt';

const packages = safariPackages.map((p) =>
  canonicalPackage({
    id: p.id,
    name: p.name,
    countryName: 'Kenya',
    duration: p.duration,
    priceFrom: minSeasonPrice(p.seasons), // only 6 of 21 carry real season rates → rest "Contact for pricing"
    description: p.description,
    highlights: p.highlights || [],
    regions: p.destinations || [],
    coverImage: p.coverImage,
    difficulty: p.difficulty,
    featured: !!p.featured,
    itinerary: p.itinerary,
    seasons: p.seasons,
  })
);

export const kenyaDestination = {
  key: 'kenya',
  name: 'Kenya',
  emoji: '🇰🇪',
  tagline: 'Home of the Great Wildebeest Migration and iconic national parks',
  signature: 'The Great Migration',
  heroImage:
    'https://images.unsplash.com/photo-1520124442480-b5c60b0f80c2?w=1920&h=1080&auto=format&fit=crop&q=80&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8a2VueWF8ZW58MHx8MHx8fDA%3D',
  highlights: ['Maasai Mara', 'Amboseli', 'Tsavo', 'Lake Nakuru', 'Samburu', 'Aberdare', 'Mount Kenya', 'Lake Naivasha'],
  bestTime: 'July-October (Great Migration), December-March (Calving season)',
  wildlife: ['Big Five', 'Great Migration', 'Elephants', 'Flamingos', 'Rhinos', 'Giraffes', 'Lions'],
  climate: 'Tropical with dry seasons',
  currency: 'Kenyan Shilling (KES)',
  language: 'English, Swahili',
  mapCenter: [-1.2921, 36.8219],
  mapMarkers: [
    { position: [-1.4096, 35.1116], name: 'Masai Mara' },
    { position: [-2.6531, 37.2597], name: 'Amboseli' },
    { position: [-0.3667, 36.0833], name: 'Lake Nakuru' },
    { position: [-2.7876, 37.6852], name: 'Tsavo' },
  ],
  packages,
  weather: {
    current: 'Sunny, 24°C',
    forecast: 'Clear skies expected',
  },
};
